import { memo, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { LoanService } from '../../services';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Delete from '@material-ui/icons/Delete';
import ConfirmationModal from '../../components/ConfirmationModal'
import { formatDate, getCurrentDateFormatted } from '../../utils/formatters';
import { useRole } from '../../contexts/RolesContext';
import { useError } from '../../contexts/ErrorContext';

const DeletePaymentButtons = ({selectedRowIndices, potentialDeletions, date}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { hasRole, isAdmin } = useRole();
  const { showError } = useError();

  const toggleConfirmation = () => setShowConfirmation(!showConfirmation);

  const handleDeleteClick = () => {
    toggleConfirmation();
    const paymentIds = selectedRowIndices.map(rowId => potentialDeletions[rowId].id);
    LoanService.deletePayments(paymentIds).then(() => {
      // !FIXME: Do this better!
      window.location.reload();
    }).catch(showError);
  }

  return (formatDate(date) === getCurrentDateFormatted() && (isAdmin()  && !hasRole('cs')) ? (
    <>
    <Fragment>
        <Tooltip title={"Delete Payments"}>
          <IconButton onClick={toggleConfirmation}>
            <Delete />
          </IconButton>
        </Tooltip>
    </Fragment>
    <ConfirmationModal
      title="Confirm"
      message="Are you sure you want to delete these payments?"
      onConfirm={handleDeleteClick}
      onCancel={toggleConfirmation}
      showConfirmationBox={showConfirmation}
    />
    </>
  ) : null);
}

DeletePaymentButtons.propTypes = {
  selectedRowIndices: PropTypes.arrayOf(PropTypes.number),
  potentialDeletions: PropTypes.arrayOf(PropTypes.object),
  date: PropTypes.instanceOf(Date)
};

export default memo(DeletePaymentButtons);